import React from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../context/hooks";
import useFleetManagerContext from "../../context/hooks/useFleetManagerContext";
import { ParkingProductType } from "../../models";
import { deletePedestrianDelegees } from "../../services/pedestrianRights.service";
import { useAppDispatch, useAppSelector } from "../../store";
import parkingProductsActions from "../../store/actions/parkingProducts.actions";
import Warning from "./Warning";

type FormOptions = {
    warning: string;
    warningDescription: string;
};

interface IFormProps {
    onRefresh: () => void;
    options: FormOptions;
    productType?: ParkingProductType;
}

const BatchDeleteDelegeeWarning: React.FC<IFormProps> = ({ onRefresh, productType, options }) => {
    const loading = useAppSelector(s => s.parkingProducts.loading || s.pedestrianRights.pedestrianProducts.loading);
    const { t } = useTranslation("globals");
    const dispatch = useAppDispatch();

    const { appState } = useAppContext();

    const { fleetManagerState, setSelectedParkingRightIds, toggleBatchDeleteDelegationsWarning } =
        useFleetManagerContext();

    const closeAndClearSelection = () => {
        toggleBatchDeleteDelegationsWarning();
        setSelectedParkingRightIds([]);
    };

    const handleDeleteConfirmation = () => {
        if (productType === ParkingProductType.PedestrianAccess) {
            dispatch(
                deletePedestrianDelegees({
                    model: {
                        customerId: appState.user.seasonTicketOwnerCrmId!,
                        delegeeIds: fleetManagerState.selectedRowKeys
                    },
                    // this is used for optimistic updates for my products which is not need for my fleet delete
                    delegeePmcIds: [] 
                }, () => closeAndClearSelection())
            );
            return;
        }
        dispatch(
            parkingProductsActions.deleteDelegations(
                { 
                    registrationIds: fleetManagerState.selectedRowKeys,
                    seasonTicketOwnerCrmId: appState.user.seasonTicketOwnerCrmId!
                 },
                () => {
                    onRefresh();
                    closeAndClearSelection();
                }
            )
        );
    };

    return (
        <Warning
            warning={options.warning}
            details={options.warningDescription}
            onCancel={toggleBatchDeleteDelegationsWarning}
            onConfirm={handleDeleteConfirmation}
            confirmText={t("delete")}
            disabled={loading}
        />
    );
};

export default BatchDeleteDelegeeWarning;
